import React from 'react';
import { Group, Stack } from '@mantine/core';

import { AMPLICON, GENOMIC, TOTAL_CARBON, TOTAL_INORGANIC_CARBON } from 'constants/analysis';

import { BatchFormType } from 'store/batches/types';

import { BatchCarouselSelect } from './FormInputs/BatchCarouselSelector';
import { BatchUnitSelect } from './FormInputs/BatchUnitSelector';
import { FormRows } from './FormRows';

type BatchFormContainerPropsType = {
  batch: BatchFormType;
  onValueChange: (
    attributeKey: keyof BatchFormType,
    newValue: number | string | string[] | { [key: string]: any },
  ) => void;
};

export const BatchFormContainer = ({ batch, onValueChange }: BatchFormContainerPropsType) => {
  const getPlateForm = () => {
    switch (batch.type) {
      case AMPLICON:
      case GENOMIC:
        return <FormRows batch={batch} onValueChange={onValueChange} showLanes />;
      case TOTAL_CARBON:
      case TOTAL_INORGANIC_CARBON:
        return (
          <Group align="flex-start" justify="flex-start">
            <FormRows batch={batch} onValueChange={onValueChange} />
            <Stack w="12.5rem">
              <BatchUnitSelect batch={batch} onValueChange={onValueChange} showLabel />
              <BatchCarouselSelect batch={batch} onValueChange={onValueChange} showLabel />
            </Stack>
          </Group>
        );
      default:
        return <FormRows batch={batch} onValueChange={onValueChange} />;
    }
  };

  return getPlateForm();
};
